import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};
export const AllHookloaderDeployedReport = async (StartDate, endData, VehicleNumber) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `RawReport/GetAllDeployedHookLoadersTransaction?startDate=${StartDate}&endDate=${endData}&VehicleNumber=${VehicleNumber}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};